<template>
  <div class="animate-panel"  data-child="hpanel" data-effect="fadeInDown">
    <div class="hpanel no-margins" >
      <template v-if="documents.length !== 0">

        <div class="panel-heading hbuilt ">

          <div class="row">
            <div class="col-xs-6 text-center">
              Best Documents: <span class="font-extra-bold m-t-xl m-b-xs text-info" >{{bestExperts}}</span>
            </div>
            <div class="col-xs-6 text-center">
              Total Documents estimate: <span class="font-extra-bold m-t-xl m-b-xs" style="">{{nbEstimateDocument}}</span>
            </div>
          </div>

          <div class="row">

          </div>

        </div>

        <div class="panel-body no-padding ">
          <table style="width: 100%">
            <tr style="height: 25px">
              <th class="col-md-5"><span>Title</span></th>
              <th class="col-md-4 "><span>Authors</span></th>
              <th class="col-md-2 text-center"><span role="button" @click="changeSort('pubDate')">Publication Date<i style="padding-left: 15px" class="fa fa-sort"></i></span><span></span></th>
              <th class="col-md-1 text-center"><span>Action</span></th>
            </tr>
          </table>
          <div v-if="documents.length !== 0" >
            <div v-for="(document, key) in documents" v-if="document && key < context.nbItemsDisplay" :key="key + '-' + document.documentID" class="clearfix ">

              <document-top :key="key + '-' + document.documentID + '-' + documents[key].biblio" v-model="documents[key]"
                            :context="context"/>

              <div class="col-xs-12 collapse" :id="'collapse-'+ documents[key].documentID" style="padding: 20px">
                <document-item :key="key + '-' + document.documentID + '-' + documents[key].biblio"
                               v-model="documents[key]" :context="context"/>
              </div>
            </div>

            <div class="text-center" style="padding: 25px" v-if="documents.length > context.nbItemsDisplay">
              <button class="btn btn-primary btn-xs" :class="documents.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayMore">Display more</button>
              <button class="btn btn-primary btn-xs" :class="documents.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayAll">Display all</button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import DocumentTop from '../documents/DocumentTop'
import DocumentItem from '../documents/DocumentItem'

export default {
  components: {
    DocumentItem,
    DocumentTop
  },
  props: ['context', 'value', 'nbEstimateDocument', 'nbDocuments', 'listType', 'changeSort'],
  name: 'ListDocumentsResults',
  watch: {
    value: function (val) {
      this.documents = val
    }
  },
  data () {
    return {
      documents: null
    }
  },
  computed: {
    bestExperts: function () {
      return this.nbDocuments
    }
  },
  methods: {
    estimateExperts: function () {
      let factor = this.nbDocuments / this.nbResults

      let estimateExpert = Math.round(factor * this.totalNbResults)

      this.overlay = (estimateExpert >= 60000)

      return estimateExpert.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }
  },
  mounted () {
    $(document).on('click', '.filter .dropdown-menu', function (e) {
      e.stopPropagation()
    })
  },
  beforeMount () {
    this.documents = this.value

    // this.context.name = 'documentResult'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListDocuments/ListDocumentsResults.vue